import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArmchair: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArmchair"><Path d="M3.5 11.5H7.5V14.5H16.5V11.5H20.5V18.5H3.5V11.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M18.5 11.5V3.5H5.5V11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 18.5V20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M18.5 18.5V20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArmchair;
